const removeUser = (_root, variables, { cache }) => {
  cache.writeData({ data: { user: null } })
  return null
}

export default removeUser
